import { Schema as S } from "effect";
import { PrescriptionActType } from "../list-prescriptions/list-prescriptions.request";

/**
 * Summary of a linked medication
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const med: MedicationSummary = { id: "med1", phNLabel: "Ibuprofen 400mg" }
 * ```
 */
export const MedicationSummarySchema = S.Struct({
  id: S.String,
  phPZN: S.optional(S.String),
  phNLabel: S.optional(S.String),
  phForm: S.optional(S.String),
  phPackSize: S.optional(S.String),
  phCompany: S.optional(S.String),
  phNote: S.optional(S.String),
});

export type MedicationSummary = S.Schema.Type<typeof MedicationSummarySchema>;

/**
 * Detailed prescription with linked medications and optional eRezept bundles
 *
 * @since 1.0.0
 */
export const PrescriptionDetailSchema = S.Struct({
  id: S.String,
  actType: PrescriptionActType,
  patientId: S.String,
  medicationName: S.String,
  status: S.String,
  prescriptionDate: S.optional(S.String),
  content: S.optional(S.String),
  comment: S.optional(S.String),
  employeeName: S.optional(S.String),
  medications: S.Array(MedicationSummarySchema),
  bundles: S.optional(S.Array(S.Unknown)),
  nightTime: S.optional(S.Boolean),
  printCount: S.optional(S.Number),
});

export type PrescriptionDetail = S.Schema.Type<
  typeof PrescriptionDetailSchema
>;
